import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { UnenrolledDeviceStoreActions } from '../unenrolled-device';

@Injectable({ providedIn: 'root' })
export class UnenrolledDeviceResolver {
  private readonly deviceStore = inject(Store);

  resolve(): Observable<boolean> {
    this.deviceStore.dispatch(
      UnenrolledDeviceStoreActions.UnenrolledDeviceResolverActions.unenrolledDevicesRequested()
    );
    return of(true);
  }
}
